import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HdmuiAvatarComponent } from '@heidelberg/hdmui-angular';
import { UiSharedModule } from '../ui-shared/ui-shared.module';
import { AppTitleComponent } from './app-title.component';
import { AppToolbarComponent } from './app-toolbar.component';
import { NavComponent } from './nav.component';
import { NavigationService } from './navigation.service';
import { OrganizationToolbarTitleComponent } from './org-toolbar-title.component';

@NgModule({
  imports: [
    CommonModule,
    UiSharedModule,
    RouterModule,
    HdmuiAvatarComponent
  ],
  providers: [
    NavigationService
  ],
  declarations: [
    AppToolbarComponent,
    NavComponent,
    AppTitleComponent,
    OrganizationToolbarTitleComponent
  ],
  exports: [
    AppToolbarComponent,
    NavComponent,
    AppTitleComponent,
    OrganizationToolbarTitleComponent
  ]

})


export class NavigationModule {

}
